export default __webpack_public_path__ + "static/media/stranded.de32f01d.jpeg";